"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faqModuleFragment = void 0;
var _fetching = require("@ori/fetching");
const faqModuleFragment = exports.faqModuleFragment = (0, _fetching.gql)`
  fragment FaqModule on EditorialFrequentlyAskedQuestions {
    __typename
    id
    questions {
      __typename
      title
      content {
        __typename
        text
        textLinks {
          relativeUrl
          title
          id
        }
      }
    }
  }
`;
